<template>
    <form @submit.prevent="submitForm" >
        <div class="row">
            <div class="col-md-6">
                <field-text required v-model="form.number" label="شماره" placeholder=""/>
                <field-text required v-model="form.message" label="وضعیت" placeholder=""/>
            </div>
            <div class="col-md-6">
               </div>
        </div>

        <alert :success="success" :danger="danger"></alert>
        <button-submit title="ثبت"/>
    </form>
</template>

<script>
    import ButtonSubmit from "../ButtonSubmit";
    import Alert from "../Alert";
    import FieldPassword from "../fields/FieldPassword";
    import FieldMobile from "../fields/FieldMobile";
    import FieldEmail from "../fields/FieldEmail";

    import mixinForm from "../../mixins/mixinForm";
    import FieldSelect from "../fields/FieldSelect";
    import FieldText from "../fields/FieldText";

    export default {
        mixins: [mixinForm],
        components: {
            FieldSelect,
            FieldText,
            FieldEmail,
            FieldMobile,
            FieldPassword,
            Alert,
            ButtonSubmit,
        },
        name: "FormOrderStatus",
        data() {
            return {
               
                action: "/fa/v1/order-status",
            }
        },
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/forms/FormOrderStatus.vue